<template>
  <div class="bg-warning-secondary warning_wrapper">
    <p class="mb-2 font-bold" v-html="title"></p>
    <p class="mb-0" v-html="subtitle"></p>
  </div>
</template>

<script>
export default {
  name: 'StatusBanner',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/vuesax/_variables';

.warning_wrapper {
  padding: $size-2 $size-3;
  border-radius: $size-1;
  max-width: 858px;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 4px;
    height: 100%;
    background: #ffa236;
  }
}
</style>
